import { render, staticRenderFns } from "./DistrictsComponent.vue?vue&type=template&id=8dc473fa&scoped=true"
import script from "./DistrictsComponent.vue?vue&type=script&lang=js"
export * from "./DistrictsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc473fa",
  null
  
)

export default component.exports